import React, { ReactNode } from 'react';

import { BlogAskADemo as BlogAsk } from '../../components/BlogAskADemo';
import { classNames } from '../../utils/style';
import { useScreenSize } from '../../utils/utils';
import { ImageProps } from '../../components/Image/types';

export interface BlogAskADemoProps {
  title: ReactNode;
  ctas: ReactNode;
  image?: ImageProps;
}

export const BlogAskADemoLayout = ({
  title,
  image,
  ctas,
}: BlogAskADemoProps) => {
  const screenSize = useScreenSize();
  const isMobile = ['xs', 'sm'].includes(screenSize);

  return (
    <BlogAsk>
      <BlogAsk.Content
        className={classNames('BlogAskADemoLayout')}
        type={image ? 'image' : 'text'}
      >
        <BlogAsk.ZoneText type={image ? 'image' : 'text'}>
          {title}
        </BlogAsk.ZoneText>
        {ctas && (
          <BlogAsk.ZoneButton ctas={ctas} hasImage={image ? true : false} />
        )}
      </BlogAsk.Content>
      {image && !isMobile && (
        <BlogAsk.ImageBox>
          {image && (
            <BlogAsk.Image
              {...image}
              className={classNames('object-cover w-full h-full')}
            />
          )}
        </BlogAsk.ImageBox>
      )}
    </BlogAsk>
  );
};
